/**
 * @generated SignedSource<<9ec3ebaafe97a4877fd4728337d1240a>>
 * @relayHash de6e2bac8a58a1f311e29bca101d04f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e41a183f07082b19942dc28b868628bc31ce5d5b683a639aab2d17f96750539e

import type { ConcreteRequest } from 'relay-runtime';
export type standardToPremiumModalQuery$variables = {
  cloudId: string;
  hamsProductKey: string;
};
export type standardToPremiumModalQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly experienceCapabilities: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null> | null;
};
export type standardToPremiumModalQuery = {
  response: standardToPremiumModalQuery$data;
  variables: standardToPremiumModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hamsProductKey"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "hamsProductKey"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "offeringName",
    "value": "Premium"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "standardToPremiumModalQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      {
                        "args": (v3/*: any*/),
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/)
                        ],
                        "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "standardToPremiumModalQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "args": (v3/*: any*/),
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e41a183f07082b19942dc28b868628bc31ce5d5b683a639aab2d17f96750539e",
    "metadata": {},
    "name": "standardToPremiumModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2c7841c5e5f86c438cbec88e2db2ae41";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
